import React, { Component } from 'react';
import {Doughnut} from 'react-chartjs-2';

import '../estaHome.css';
import './fallBack.css';

import functions from '../../../../functions/Estadisticas/getData';

class Fallback extends Component{
    
    constructor(){
        super();
        this.state = {
            porcenFallbacks: 0,
            data:{
                labels: [],
                datasets: [{
                    borderColor: '',
                    data: [],
                    backgroundColor: [
                    ],
                }]
            }
        };

        functions.GetDataFallBack().then((datos) => {
            
            let porcent = (datos * 100).toFixed(2);
            this.setState({
                porcenFallbacks: porcent,
                data:{
                    labels: ["FallBacks"],
                    datasets: [{
                        borderColor: 'rgb(63, 80, 121)',
                        data: [porcent, 100],
                        backgroundColor: [
                            'rgba(238,60,22,0.6)',
                            'rgba(22,238,238,0.6)',
                        ],
                    }]
                }
            });
        });
    }


    render(){
        return(
            <div className='col s12 m6 xl4'>
                <div className='card-panel empresaCard fallBackCard'>
                    <p>FallBacks</p>
                    <div className='contDonout'>
                        <Doughnut data={this.state.data} id='donoutChart'/>
                        <p>{this.state.porcenFallbacks + ' %'}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Fallback;